import { LayoutDrawer } from '../../components/layout/layout-drawer.tsx';
import type { UnassignedJobsDrawerProps } from './unassigned-jobs-drawer.types.ts';
import { useLayoutEffect, useRef } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import { UnassignedJobsDrawerItem } from './unassigned-jobs-drawer-item.tsx';
import styles from './unassigned-jobs-drawer.module.scss';

export function UnassignedJobsDrawer({
  data,
  width,
  maxWidth,
  position,
  open,
  onOpen,
  onOpenDialog,
}: UnassignedJobsDrawerProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const scrollTopRef = useRef<number | null>(null);

  useLayoutEffect(() => {
    if (contentRef.current) {
      if (scrollTopRef.current !== null) {
        contentRef.current.scrollTop = scrollTopRef.current;
      }
      scrollTopRef.current = contentRef.current.scrollTop;
    }
  });

  const rowVirtualizer = useVirtualizer({
    count: data?.length ?? 0,
    getScrollElement: () => contentRef.current,
    estimateSize: () => 170,
    overscan: 3,
  });

  const handleScroll = () => {
    if (contentRef.current) {
      scrollTopRef.current = contentRef.current.scrollTop;
    }
  };

  return (
    <LayoutDrawer
      title={'Unassigned Jobs'}
      width={width}
      maxWidth={maxWidth}
      position={position}
      open={open}
      onOpen={onOpen}
    >
      <div className={styles.container}>
        <div ref={contentRef} className={styles.content} onScroll={handleScroll}>
          <div className={styles.virtualContainer} style={{ height: rowVirtualizer.getTotalSize() }}>
            {rowVirtualizer.getVirtualItems().map((virtualRow) => {
              const job = data[virtualRow.index];
              return (
                <div
                  key={virtualRow.index}
                  data-index={virtualRow.index}
                  ref={rowVirtualizer.measureElement}
                  className={styles.virtualItem}
                  style={{ transform: `translateY(${virtualRow.start}px)` }}
                >
                  <UnassignedJobsDrawerItem job={job} onOpenDialog={onOpenDialog} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </LayoutDrawer>
  );
}
